import STATIC_ROUTES from '@data/staticRoutes.json';

import ButtonLink from '../buttonLinks/ButtonLink';
import { ONLINE_TRANSACTION_LINKS } from './const';
import MenuLink from './MenuLink';
import { MobileHeaderReservationsWrapper } from './styled';

const MobileTransactions = () => {
  return (
    <MobileHeaderReservationsWrapper>
      {ONLINE_TRANSACTION_LINKS.map(({ id, href, title, icon }) => (
        <MenuLink title={title} key={id} href={href} icon={icon} />
      ))}
      <ButtonLink
        label='HEMEN BAŞVUR'
        href={STATIC_ROUTES.sfCardApplication}
        icon='SFCreditCard'
      />
    </MobileHeaderReservationsWrapper>
  );
};

export default MobileTransactions;
